import head from 'lodash/head';
import { IMG_POSTFIX } from '@yme/utils/constants';
import { filterLabelKeyMap } from './constants';
export function getProductCardImage(image = '') {
    return image.replace(IMG_POSTFIX.thumbnail, '');
}
export function getPrices(variantWithLowestPrice, currency_code) {
    if (variantWithLowestPrice && currency_code) {
        const { price_variant, sale_price_variant } = variantWithLowestPrice;
        const price = {
            amount: head(price_variant) ?? 0,
            currencyCode: currency_code,
            discount: sale_price_variant
                ? {
                    discountValue: 0,
                    discountedPrice: head(sale_price_variant) ?? 0,
                }
                : undefined,
        };
        return [price];
    }
    return [];
}
export function getCountAppliedValues(values) {
    return values.filter((item) => item.checked).length;
}
export function getCountAppliedFilters(facets) {
    return facets.filter((facet) => facet.values.some((item) => item.checked)).length;
}
export function getFilterLabelKey(name) {
    return filterLabelKeyMap[name] || '';
}
export function getPillsOptions(facets, t, handleUpdateFacets) {
    const pills = facets.map((facet) => {
        const values = facet.values.filter((item) => item.checked).map((item) => item.name);
        const finallyValue = values.length <= 2
            ? values.slice(0, 2).join(', ')
            : `${values.slice(0, 2).join(', ')}... +${values.slice(2).length}`;
        return {
            groupId: facet.name,
            label: t(getFilterLabelKey(facet.name)),
            value: finallyValue,
            fullToolTipLabel: values.length > 2 ? values.join(', ') : undefined,
            handleDelete: (id) => handleUpdateFacets(id)([]),
        };
    });
    return pills;
}
